"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomEventsOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomEventsOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.605 6.552c.214-.058.395-.262.395-.483V3.75a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 3.75v2.319c0 .221.181.425.395.483a1.5 1.5 0 0 1 0 2.895C.181 9.506 0 9.71 0 9.931v2.319a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V9.93c0-.22-.181-.425-.395-.483a1.5 1.5 0 0 1 0-2.895ZM15 10.292v1.958a.5.5 0 0 1-.5.5h-2V12a.5.5 0 0 0-1 0v.75h-10a.5.5 0 0 1-.5-.5v-1.959A2.506 2.506 0 0 0 2.5 8c0-1.003-.601-1.9-1.5-2.292V3.75a.5.5 0 0 1 .5-.5h10V4a.5.5 0 0 0 1 0v-.75h2a.5.5 0 0 1 .5.5v1.958A2.506 2.506 0 0 0 13.5 8c0 1.002.601 1.899 1.5 2.292ZM12 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 12 6Zm-3.055.777L7.72 6.599l-.548-1.11a.729.729 0 0 0-.657-.41.73.73 0 0 0-.658.41L5.309 6.6l-1.224.178a.728.728 0 0 0-.593.499.728.728 0 0 0 .186.752l.886.864-.21 1.22a.73.73 0 0 0 .293.717.73.73 0 0 0 .772.056l1.096-.576 1.095.576c.248.13.544.11.772-.056a.73.73 0 0 0 .292-.718l-.21-1.22.888-.864a.728.728 0 0 0 .185-.751.727.727 0 0 0-.592-.499ZM7.391 8.543l.207 1.205-1.083-.57-1.083.57.207-1.205-.876-.854 1.21-.176.542-1.097.541 1.097 1.21.176-.875.854Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomEventsOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomEventsOutline;
exports["default"] = _default;